<template>
  <SelectWithSearch
    label="Código da Natureza"
    v-model="input"
    :resizeSearchField="false"
    :change="change"
    :options="nfseNatureCodesCollection"
    :error="error"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">{{ props.data.label }}</div>
    </template>
    <template slot="no-options"> Selecione um código </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">{{ props.data.label }}</div>
    </template>
  </SelectWithSearch>
</template>

<script>
import { SelectWithSearch } from '@/components/Form';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SelectNfseNatureCode',
  components: {
    SelectWithSearch,
  },
  props: {
    value: {},
    error: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      input: null,
    };
  },
  async mounted() {
    await this.setNfseNatureCodesCollection();
  },
  computed: {
    ...mapState('fiscalComponents', ['nfseNatureCodesCollection']),
  },
  methods: {
    ...mapActions('fiscalComponents', ['setNfseNatureCodesCollection']),

    change(value) {
      this.$emit('input', value);
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
};
</script>
